import { render, staticRenderFns } from "./Report_blockchain.vue?vue&type=template&id=391d9e48&"
import script from "./Report_blockchain.vue?vue&type=script&lang=js&"
export * from "./Report_blockchain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports